module.exports = __webpack_public_path__ + "static/img/8ways_en.f11a83c0.png";